"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPermissionAction = void 0;
const constant_1 = require("../../constant");
const setPermissionAction = (payload) => ({ type: constant_1.SET_PERMISSION, payload });
exports.setPermissionAction = setPermissionAction;
